import * as React from 'react';
import { PropertyPanel } from 'app/infrastructure/ui/renderer/property-panel';
import styles from './fallback.scss';

/**
 * A debugging panel to inspect errors or component properties
 */
export class InspectionPanel extends React.PureComponent<any, any>{
  public hide = () => {
    this.props.actions.inspect(undefined);
  }

  private handlePreviewEdit = (preview: any) => {
    this.props.actions.preview(preview);
  }

  public render(){

    const title = this.props.$inspectedError ?
                  <div className={styles.popoverMessage}> ⚠️ <strong> Problem:</strong> {this.props.$inspectedError.message}</div> :
                  <div className={styles.popoverMessage}>
                    Inspecting <strong>{this.props.$inspectedComponent.componentDescriptor.label}</strong></div>;

    return <div className={styles.popoverContent}>

          <button style={{color: 'rgba(211, 216, 55, 0.57)', opacity: 1}} onClick={this.hide}
                  type="button" className="close" aria-label="Close"><span aria-hidden="true">&times;</span>
          </button>

        {title}

        <PropertyPanel
          {...this.props.$inspectedComponent}
          $inspectedError={this.props.$inspectedError}
          onUpdatePreview={this.handlePreviewEdit}
        />
      </div>;
  }
}
